import type { PortalAssignmentSession } from "../../hooks/use-programs";

export const startOfDay = (date: Date): Date => {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d;
};

export const isSameCalendarDay = (a: Date, b: Date): boolean =>
  a.getFullYear() === b.getFullYear() &&
  a.getMonth() === b.getMonth() &&
  a.getDate() === b.getDate();

export const getWeekDaysContaining = (anchor: Date): Date[] => {
  const d = startOfDay(anchor);
  const weekday = d.getDay();
  const mondayOffset = weekday === 0 ? -6 : 1 - weekday;
  const monday = new Date(d);
  monday.setDate(d.getDate() + mondayOffset);
  return Array.from({ length: 7 }, (_, index) => {
    const day = new Date(monday);
    day.setDate(monday.getDate() + index);
    return day;
  });
};

export const sessionMatchesDate = (
  session: Pick<PortalAssignmentSession, "scheduledAt">,
  date: Date,
): boolean => {
  if (!session.scheduledAt) return false;
  return isSameCalendarDay(new Date(session.scheduledAt), date);
};

export const getCurrentCycleSessions = (
  sessions: PortalAssignmentSession[],
  completedCyclesCount: number,
): PortalAssignmentSession[] =>
  sessions
    .filter((session) => session.cycleIndex === completedCyclesCount)
    .sort((a, b) =>
      a.weekIndex !== b.weekIndex
        ? a.weekIndex - b.weekIndex
        : a.position - b.position,
    );

export const shouldUseProgramCalendarView = (
  sessions: PortalAssignmentSession[],
  completedCyclesCount: number,
): boolean => {
  const current = getCurrentCycleSessions(sessions, completedCyclesCount);
  if (current.length === 0) return false;
  return (
    current.length > 1 || current.some((session) => session.scheduledAt != null)
  );
};

export const getSessionsForDate = (
  sessions: PortalAssignmentSession[],
  date: Date,
): PortalAssignmentSession[] =>
  sessions.filter((session) => sessionMatchesDate(session, date));
